import { useRoutes } from 'react-router';
import IntervieweeRoute from './interviewee/route';
import InterviewerRoute from './interviewer/route';
import NotFoundRoute from './shared/404';

export default function Routes() {
  return useRoutes([InterviewerRoute, IntervieweeRoute, NotFoundRoute]);
}
